module.exports = __webpack_public_path__ + "img/sejong_detail.457f0d43.jpg";